import React from "react";
import {
  BsArrowLeft,
  BsFillBookmarkFill,
  BsFillCaretRightFill,
} from "react-icons/bs";
import { TbMathGreater, TbMathLower } from "react-icons/tb";
// @ts-ignore
import Bulb from "../../Assets/Images/Sat-images/Isolation_Mode.webp";
// @ts-ignore
import download from "../../Assets/Images/Sat-images/download-icon.webp";
import { AiFillStar } from "react-icons/ai";
// @ts-ignore
import ReactHlsPlayer from "react-hls-player";

export interface ReviewStaric {
  id: number;
  isFilled: boolean;
}

export interface VideoPlayerProps {
  id: string | number;
  chapterTitle: string;
  topicTitle: string;
  description: string;
  video: string;
  isLoading: boolean;
  isError: string | boolean;
  Error?: string;
  HandleArrow: () => void;
  checkClampLines: boolean;
  setCheckClampLines: (val: boolean) => void;
  handlePlay: () => void;
  HandlePauseVideo: () => void;
  videoRef: React.RefObject<any>;
  isEqual: boolean;
  HandleNextVideo: () => void;
  innerWidth: number;
  videoUrl: string;
  pdfUrl: string;
  reviewStaric: ReviewStaric[];
  HandleStaric: (index: number) => void;
  HandleSubmit: () => void;
}

const VideoPlayer: React.FC<VideoPlayerProps> = (props) => {
  const downloadFile = async () => {
    const pdfUrl = `${props.pdfUrl ? props.pdfUrl : ""}`;
    const link = document.createElement("a");
    link.href = pdfUrl;
    link.target = "_blank";
    link.download = "downloaded.pdf";
    link.click();
  };

  const operator = ">";
  return (
    <>
      <div className="Home-Container">
        {props.isError ? (
          <h1>{props.Error}</h1>
        ) : (
          <div className="home-sub-container">
            <div className="main-right-container">
              <div className="video-player-sub-banner-first-section">
                <div onClick={props.HandleArrow}>
                  <BsArrowLeft size="22px" />
                </div>
                <div className="favourite-icon">
                  <BsFillBookmarkFill size="15px" color="#A20107" />
                </div>
              </div>
              <div className="second-section">
                <ReactHlsPlayer
                  src={props.videoUrl ? props.videoUrl : ""}
                  autoPlay={false}
                  onPause={() => {
                    props.HandlePauseVideo();
                  }}
                  controls={true}
                  playerRef={props.videoRef}
                  onPlay={() => {
                    props.handlePlay();
                  }}
                  className="video-player"
                  width="100%"
                  height="auto"
                />
              </div>

              {props.innerWidth < 1024 ? (
                ""
              ) : (
                <>
                  {props.chapterTitle === "Bookmark" ? (
                    ""
                  ) : (
                    <div className="third-section-video-player">
                      <div className="third-panel">
                        <div className="third-left">
                          <div className="icon-div-video">
                            <div className="bs-care-bg">
                              <BsFillCaretRightFill size="10px" color="#ffff" />
                            </div>
                          </div>
                          <div className="left-section-right">
                            <div className="video-title">
                              {props.topicTitle ? props.topicTitle : ""}
                            </div>
                            <div className="video-lesson">12:00</div>
                          </div>
                        </div>
                        <div className="third-right">
                          <div className="div">
                            <TbMathLower size="10px" />
                            <span className="third-right-head">
                              Previous Video
                            </span>
                          </div>
                          <div className="line"></div>
                          <div
                            className="next-video"
                            onClick={() => {
                              props.HandleNextVideo();
                            }}
                          >
                            <span
                              className={
                                props.isEqual
                                  ? "third-right-head"
                                  : "third-right-head  disable-color"
                              }
                            >
                              Next video
                            </span>
                            <TbMathGreater size="10px" />
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                </>
              )}
              <div className="video-player-title-panel">
                <div className="video-title-heading">
                  {" "}
                  {props.chapterTitle ? props.chapterTitle : ""}
                </div>
                <div className="video-title-icon">
                  <AiFillStar size="17px" fill="#FFAA00 " />
                  <span className="four-rating"> 4.0</span>
                </div>
              </div>
              <div className="video-Pargraph-section">
                <div className="video-player-para-title">
                  {props.topicTitle ? props.topicTitle : ""}
                </div>
                <p className={props.checkClampLines ? "no-line-clamp" : ""}>
                  {props.description ? props.description : ""}
                </p>
                {props.checkClampLines ? (
                  <p
                    className="see-more"
                    onClick={() => {
                      props.setCheckClampLines(false);
                    }}
                  >
                    see more
                  </p>
                ) : (
                  <p
                    className="see-more"
                    onClick={() => {
                      props.setCheckClampLines(true);
                    }}
                  >
                    see less
                  </p>
                )}
              </div>
              <div className="video-buttons-section">
                <div
                  className="download-button"
                  onClick={() => {
                    downloadFile();
                  }}
                >
                  <img src={download} width="30px" height="30px" alt="Download" />
                  <p>Download Files</p>
                </div>

                <div className="bulb-button">
                  <img src={Bulb} width="30px" height="30px" alt="Quiz" />
                  <p>Quiz</p>
                </div>
              </div>
              {props.chapterTitle === "Bookmark" ? (
                ""
              ) : (
                <>
                  {props.innerWidth < 1024 ? (
                    <div className="responsive-panel">
                      <div
                        className={
                          props.isEqual
                            ? "resp-previous-button change-resp-previous"
                            : "resp-previous-button"
                        }
                      >
                        Previous Video
                      </div>
                      <div
                        className={
                          props.isEqual
                            ? "resp-next-button change-resp-next "
                            : "resp-next-button"
                        }
                        onClick={() => {
                          props.HandleNextVideo();
                        }}
                      >
                        Next Video
                      </div>
                    </div>
                  ) : (
                    ""
                  )}
                </>
              )}
            </div>
          </div>
        )}
      </div>
    </>
  );
};
export default React.memo(VideoPlayer);
